import React, { useEffect } from 'react';
import { makeStyles, Link } from '@material-ui/core';
import { useTranslation } from "react-i18next";
import { useHistory } from 'react-router-dom';

import useResendVerification from './useResendVerification';
import { HOME_URL } from '../../const/URL.const';

import { useSnackbarMessages } from "../../yoello-lib/modules/components/snackbar/SnackbarContext";

export interface IEmailVerificationMessage {
    emailAddress?: string;
}

const useStyles = makeStyles({
    backButton: {
        minWidth: "6px"
    },
    pageContainer: {
        width: "100%",
        height: "100%",
        backgroundColor: "#F3F4F9"
    },
    backToLogin: {},
    text: {
    },
    email: {
        fontSize: "1.1rem !important",
        fontWeight: 600,
        color: "#212121 !important"

    },
    didntReceive: {
        "& span": {
            fontSize: "0.9rem",
            color: "#737FA4",
            padding: "0 3px",
        },
        "& a": {
            color: "#4F3CC9",
            fontSize: "0.9rem",
            textDecoration: "none",
            "&:visited": {
                color: "default"
            }
        }
    },
    resend: {
        opacity: 1,
        transition: "0.25s ease-in-out",
        "&.loading": {
            opacity: 0.5
        }
    },
    buttonWrapper: {
        margin: "24px 0"
    }
});

const EmailVerificationMessage = (props: IEmailVerificationMessage) => {
    const classes = useStyles();
    const { t } = useTranslation();
    const history = useHistory();
    const { error, isLoading: verifyIsLoading, hasFinishedSending, isAlreadyVerified, sendVerification } = useResendVerification();
    const { sendSnackbarMessage } = useSnackbarMessages()!;
    useEffect(() => {
        if(error){
            sendSnackbarMessage(t("signup.form.generic_error"), 'error');
        }
    }, [error, sendSnackbarMessage, t]);
    return (
        <div>
            <p className={classes.text}>{t("signup.verification.verification_sent")}</p>
            <p className={classes.email}>{props.emailAddress}</p>
            <p className={classes.text}>{t("signup.verification.click_the_link")}</p>
            <p className={classes.didntReceive}>
                {
                    isAlreadyVerified ? 
                        <div>
                            <span>
                                {t("signup.verification.already_verified")} 
                                <Link onClick={() => {
                                    history.push(HOME_URL)
                                }}>
                                    {t("signup.verification.click_login")}
                                </Link>
                            </span>
                        </div> :
                        hasFinishedSending ? 
                            <div>
                                <span>{t("signup.verification.resent")}</span>
                            </div> :
                            <div className={`${classes.resend} ${verifyIsLoading ? 'loading' : ''}`}>
                                <span className={classes.text}>{t("signup.verification.didnt_receive")}</span>
                                <Link 
                                    className={classes.resend}
                                    onClick={sendVerification}
                                >
                                    {t("signup.verification.resend")}
                                </Link>
                            </div>
                }
            </p>
        </div>
        
    )
}

export default EmailVerificationMessage;